export const koKR_commonMenu = {
   'menu.common.search': '조회',
   'menu.common.reset': '초기화',
   'menu.common.registration': '등록',
   'menu.common.update': '수정',
   'menu.common.delete': '삭제',
   'menu.common.filter': '필터',
};
